const store = () => import("../stores/index.js");

export const parseJSON = (response) => {
  if (response.status === 204) {
    // Response with 204 status code has no content, thus no need to parse it
    return Promise.resolve({});
  }
  return response.json();
};

export const attachRecaptchaToken = async (options) => {
  const { useAccountStore } = await store();
  const { AppConfig } = useAccountStore.getState();
  let recaptchaAction =
    options && options.options && options.options.recaptcha_action;
  if (!options.header) {
    options.header = {};
  }
  if (recaptchaAction) {
    let token = await getRecaptchaToken(
      recaptchaAction,
      AppConfig.ReCaptchaSiteKey
    );
    options.header["X-Recaptcha-Token"] = token;
  }
  return options;
};

function getRecaptchaToken(action, recaptchaSitekey) {
  return new Promise((resolve) => {
    window.grecaptcha &&
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(recaptchaSitekey, { action: action })
          .then(resolve);
      });
  });
}

export const serializeQueryParams = (url, params = {}, appId) => {
  var queryString = url.lastIndexOf("?") !== -1 ? `&` : `?`;
  Object.keys(params).forEach((key) => {
    queryString += `${key}=${encodeURIComponent(params[key])}&`;
  });
  if (appId) {
    queryString += `_application_id=${appId}`;
  }
  return `${url}${queryString}`;
};

export const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    try {
      console.warn("Network Request Failed", {
        url: response.url,
        status: response.status,
        statusText: response.statusText
      });
      if (response.headers.get("Content-Type") === "application/json") {
        return response.json().then((json) => {
          return Promise.reject(
            Object.assign({ statusCode: response.status }, json)
          );
        });
      }
      return Promise.reject({
        errorMessage: "Unhandled server error",
        statusCode: response.status
      });
    } catch (err) {
      console.error(err);
      return Promise.reject({
        status: response.statusText,
        statusCode: response.status
      });
    }
  }
};

export function isKFDomain(url) {
  return url.startsWith("/");
}

export const createRequest = async (url, reqConfig) => {
  var headers = Object.assign(reqConfig.header || {});
  // Used Windows.AuthToken Since caching the api resonpse second time success .then has to trigger

  // added for low-code product
  const { useUserStore } = await store();
  const { currentAppId } = useUserStore.getState();

  if (isKFDomain(url)) {
    headers["X-Csrf-Token"] = window.accountDetails?.AuthToken;
  }
  //temp fix - need to change appId query logic
  if (reqConfig.query || currentAppId) {
    url = serializeQueryParams(
      url,
      reqConfig.query,
      reqConfig.removeAppIdQuery ? "" : currentAppId
    );
  }

  var requestOption = {
    method: reqConfig.method,
    headers: headers,
    //mandatory for sending cookie along with request.
    //to block sending cookie set "omit" which is default as per fetch's spec
    credentials: reqConfig.isCORS ? "include" : "same-origin"
    //body: (typeof reqConfig.data !== "string") ? JSON.stringify(reqConfig.data) : reqConfig.data
  };

  if (reqConfig.data) {
    requestOption["body"] =
      typeof reqConfig.data !== "string"
        ? JSON.stringify(reqConfig.data)
        : reqConfig.data;
  }

  if (reqConfig.signal) {
    requestOption["signal"] = reqConfig.signal;
  }

  return new Request(url, requestOption);
};
